import { render, staticRenderFns } from "./ScrollableHorizontalBarChart.vue?vue&type=template&id=7a63af49&lang=pug&"
import script from "./ScrollableHorizontalBarChart.vue?vue&type=script&lang=ts&"
export * from "./ScrollableHorizontalBarChart.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollableHorizontalBarChart.vue?vue&type=style&index=0&id=7a63af49&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports